import { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { RELEASE } from "../../constants/testIds";

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const decision = localStorage.getItem("ng_consent");
    if (!decision) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("ng_consent", value);
    window.dispatchEvent(new CustomEvent("ng-consent-changed", { detail: value }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid={RELEASE.consentBanner}
      className="fixed bottom-0 left-0 right-0 z-[100] flex flex-col sm:flex-row items-center gap-4 justify-between px-6 py-4 bg-[#070c22]/95 border-t border-white/10 backdrop-blur-lg"
      style={{ pointerEvents: "auto" }}
    >
      <p className="text-xs sm:text-sm text-[#b4bbdc] max-w-xl leading-relaxed">
        We use minimal, anonymous listening analytics (no ads, no tracking of you personally) to
        understand how the garden is enjoyed. You can decline and still listen freely.
      </p>
      <div className="flex gap-2 shrink-0">
        <Button
          data-testid={RELEASE.consentDecline}
          onClick={() => decide("denied")}
          variant="outline"
          className="rounded-full border-white/20 bg-transparent text-[#b4bbdc] hover:bg-white/5 hover:text-white"
        >
          Decline
        </Button>
        <Button
          data-testid={RELEASE.consentAccept}
          onClick={() => decide("granted")}
          className="rounded-full bg-[#dfe6fa] text-[#0a0e28] hover:bg-[#f2f4ff]"
        >
          Accept
        </Button>
      </div>
    </div>
  );
};
